import React, { useState } from "react";
import sideImage from "../Images/viva_bellissimoMen_2024.jpg";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import axios from "axios";
import { Button } from "./Button";
import { Link } from "react-router-dom";
function Downloads() {
  const { t } = useTranslation();
  const [allDocuments, setAllDocuments] = useState([]);
  const documents = async () => {
    try {
      const response = await axios.post(
        "https://api.bbf-bike.de/api/documents/downloads",
        { data: "websites/viva/documents" },
      );
      setAllDocuments(response.data);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    documents();
  }, []);
  const catalogArray = allDocuments?.filter((item) =>
    item.toLowerCase().includes("katalog"),
  );

  const manualsArray = allDocuments?.filter((item) =>
    item.toLowerCase().includes("betriebsanleitung"),
  );


  return (
    <div className=" min-h-[calc(100vh-68px)] h-auto bg-[#000000] lg:py-[140px]">
      <div className="container md:mx-0 sm:mx-5 p-4 md:mt-0 md:mb-0  sm:mb-0 lg:flex lg:flex-row lg:items-center md:flex md:flex-row md: justify-between md:items-center mb-28 sm:h-screen ">
        <div className="relative group  lg:flex lg:flex-row lg:items-center md:flex md:flex-col md: justify-center md:items-center sm:hidden">
          <img
            src={sideImage}
            className="md:w-[400px] h-[1000px] lg:w-[500px] object-contain"
          />
          <h1 className="absolute inset-0 mt-48 flex justify-center group-hover:opacity-50 transition-opacity text-white md:text-4xl  lg:text-6xl font-bold">
            Downloads
          </h1>
        </div>
        <div className="lg:ml-60 md:ml-[0px] flex flex-col mt-5 text-white">
          <h1 className="font-bold text-2xl mb-4"> {t("Catalogs")}</h1>

          {catalogArray.length > 0
            ? 
                <div>
                  <a
                    href={`https://media.bbf-bike.de/shop/documents/websites/viva/documents/${catalogArray.reverse()[0]}`}
                    target="blank"
                    className="mt-2 text-white capitalize">
                    {catalogArray[0].replaceAll("-", " ").replace(".pdf", "")}
                  </a>
                  <div className="border-t sm:w-[100%] md:w-[100%] lg:w-[500px] mb-4 mt-1"></div>
                </div>
           
            : ""}

          <h1 className="font-bold text-2xl mb-4 mt-6"> {t("manual")}</h1>

          {manualsArray.length > 0
            ? manualsArray.map((item, index) => (
                <div key={index}>
                  <a
                    href={`https://media.bbf-bike.de/shop/documents/websites/viva/documents/${item}`}
                    target="blank"
                    className="mt-2 text-white capitalize">
                    {item.replaceAll("-", " ").replace(".pdf", "")}
                  </a>
                  <div className="border-t sm:w-[100%] md:w-[100%] lg:w-[500px] mb-4 mt-1"></div>
                </div>
              ))
            : ""}
            <div className="mt-10">
              <Link to="/archiv">
              <button className="bg-[#A07A10] px-5 py-2">Archiv</button>
              </Link>
           
            </div>
      
        </div>
      </div>

     
    </div>
  );
}

export default Downloads;
